module.exports = __webpack_public_path__ + "img/20180815_150119_058.7a06230c.jpg";